export const whatsApp = process.env.REACT_APP_WHATSAPP_PHONE;
export const email = process.env.REACT_APP_EMAIL;
export const pixCard = process.env.REACT_APP_CARD_PIX;